import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getServerDetails } from "./actions";

export const serverEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = serverEntityAdapter.getInitialState({});

export const serverSlice = createSlice({
  name: "server",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getServerDetails.fulfilled, (state, action) => {
      if (action.payload.status) {
        serverEntityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export default serverSlice.reducer;
